/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React, { useState } from 'react';
import ThreeDotsLoader from '../LoadingDots';

export default function LoginScreen({
    DistributorID,
    password,
    setDistributorId,
    setpassword,
    ValidateUserInput,
    isError,
    setisError,
    loading,
}) {
    const [visible, setVisible] = useState('password');
    const re = /^[0-9\b]+$/;

    return (
        <div className="flex">
            <div className="sm:flex-row flex-col relative flex h-custom w-full">        
                <div className="sm:w-[40%] w-full sm:opacity-100 opacity-50">
                    <img src="images/falcon_login_image.jpg" alt="icon" className="h-custom w-full object-fill" />
                </div>
                
                <motion.div
                    animate={{ y: 20 }}
                    transition={{ ease: 'backIn', duration: 1, type: 'spring' }}  className="sm:w-[60%] w-full flex justify-center items-center distributor-page absolute sm:relative top-1/2 sm:top-0 -translate-y-1/2 sm:translate-y-0 sm:px-0 px-6">
                    <div className="sm:px-3 sm:pt-0 p-6 bg-[#FFFFFF] sm:rounded-none rounded-lg">
                        <form onSubmit={(e) => ValidateUserInput(e)}>
                            <h5 className="md:text-xs1 text-2xl font-bold text-[#555259] md:pb-6 pb-3 mb-5 text-center">Distributor Login</h5>
                            <p className="text-sm font-normal text-center text-[#555259] md:pb-[26px] pb-[18px]">Please use your registered mobile number or Distributor ID to log in</p>
                            <div className="relative">
                                <input 
                                    type="text" 
                                    maxLength="20"
                                    value={DistributorID}
                                    onInput={(e)=>{
                                        if(e.target.value.length > 20){
                                            return false                                      }
                                    }
                                    }
                                    onChange={(e)=>{
                                    
                                    
                                        if (e.target.value === '' || re.test(e.target.value)) {
                                            setDistributorId(e.target.value)                                        }
                                    }
                                    }
                                    
                                    onFocus={() => setisError(false)}
                                    id="distId" className={`md:px-3.5 px-2.5 md:h-[60px] h-12 w-full rounded-lg outline-0 border border-[#${isError?'ED1C24':'B1B4B7'}] bg-[#FFFFFF] sm:text-lg text-base font-normal text-[#${isError?'ED1C24':'090406'}] distributor-input`} autoComplete="off" />
                                <label htmlFor="distId" className={`text-xs2 md:font-semibold font-normal text-[#${isError?'ED1C24':'808285'}] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF] distributor-id`}>Mobile number or Distributor ID</label>
                            </div>
                            {isError && <motion.p
                                // animate={ x: -70, x:10 }
                                className="md:text-sm text-xs2 font-semibold text-[#ED1C24] pt-2 err-msg mb-1">Please enter a valid mobile number or Distributor ID</motion.p>}
                            <p className='text-[12px] mt-6 mb-3'>By logging in to <span className='text-[#090406]'>FALCON</span>, I agree to their <a className='text=[#090406] font-bold ' href='/terms-and-conditions' target='_blank' style={{borderBottom:'2px solid #707070'}} rel="noreferrer">Terms and Conditions</a> and <a className='text=[#090406] font-bold' style={{borderBottom:'2px solid #707070'}} href='/privacy-policy' target='_blank' rel="noreferrer">Privacy Policy.</a></p>
                            <div className="flex justify-center md:pb-6 pb-3 next">
                                {/* <!-- for disabled button bg-[#BABABA] --> */}
                                <motion.button
                                    disabled={DistributorID === ''}
                                    type='submit'
                                    // whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }} className={`md:w-[310px] w-[250px] md:h-[52px] h-10 text-center ${DistributorID !== '' ?'bg-[#555259]' : 'bg-[#BABABA]'} md:rounded-2xl rounded-xl sm:text-lg sm:font-semibold text-base text-[#FFFFFF] hover:bg-[#808285] flex justify-center items-center`}>
                                    {loading ? <ThreeDotsLoader /> : 'Next'}
                                </motion.button>
                            </div>
                            <div className="flex justify-center">
                                <p className="md:text-sm text-xs2 font-normal text-[#555259]">Not a Distributor? <button type="button" className="text-[#ED1C24] font-bold"><a href='https://adorwelding.org/Distributorship_portal/distributor_application' target="_blank" rel="noreferrer">Register Now</a></button></p>
                            </div>
                        </form>
                    </div>
                </motion.div>
            
            </div>
        </div>
    );
}
